/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CompanyFeedbackSubmissionRequest } from '../models/CompanyFeedbackSubmissionRequest';
import type { CompanyFeedbackSubmissionResponse } from '../models/CompanyFeedbackSubmissionResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompanyFeedbackService {

    /**
     * Submit Company Feedback
     * Create one attributed Jira issue without retaining feedback in CompanyOS.
     * @param requestBody
     * @returns CompanyFeedbackSubmissionResponse Successful Response
     * @throws ApiError
     */
    public static submitCompanyFeedbackApiV1CompanyFeedbackSubmissionsPost(
        requestBody: CompanyFeedbackSubmissionRequest,
    ): CancelablePromise<CompanyFeedbackSubmissionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/company-feedback/submissions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
